import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function LocationListener() {
    const location = useLocation();

    webengage.track("page viewed", {
        "page_url": window.location.href ?? ''
    });

    useEffect(() => {
        console.log('webengage page url str', window.location.href ?? '')
    }, [location])

    return null;
}

export default LocationListener;